import { Printer, FilePdf, PaperPlaneTilt, Trash, FileCsv, FileXls, CheckCircle } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { useT } from '@/i18n/LanguageContext';

export function BulkActionBar({ count, showResend, onPrint, onPdf, onResend, onMarkPrinted, onCsv, onXlsx, onDelete, onClear }) {
  const { t } = useT();
  return (
    <div
      className="bg-blue-50 border border-blue-200 rounded-md px-4 py-3 mb-3 flex flex-wrap items-center gap-2 sticky top-[72px] z-10 shadow-sm"
      data-testid="bulk-action-bar"
    >
      <span className="text-sm font-medium text-blue-900 mr-2">
        {t('hist.bulk.selected', { n: count })}
      </span>
      <Button size="sm" onClick={onPrint} data-testid="bulk-print-btn" className="bg-teal-700 hover:bg-teal-800">
        <Printer size={14} className="mr-1" /> {t('hist.bulk.print')}
      </Button>
      <Button size="sm" onClick={onPdf} data-testid="bulk-pdf-btn" variant="outline" className="bg-white text-rose-700 border-rose-300 hover:bg-rose-50">
        <FilePdf size={14} className="mr-1" /> {t('hist.bulk.pdf')}
      </Button>
      {showResend && (
        <Button size="sm" onClick={onResend} data-testid="bulk-resend-btn" variant="outline" className="text-emerald-700 border-emerald-300 bg-white hover:bg-emerald-50">
          <PaperPlaneTilt size={14} className="mr-1" /> {t('hist.bulk.resend')}
        </Button>
      )}
      <Button size="sm" onClick={onMarkPrinted} data-testid="bulk-mark-printed-btn" variant="outline" className="bg-white text-zinc-700">
        <CheckCircle size={14} className="mr-1" /> {t('hist.bulk.markPrinted')}
      </Button>
      <Button size="sm" onClick={onCsv} data-testid="bulk-export-btn" variant="outline" className="bg-white text-zinc-700">
        <FileCsv size={14} className="mr-1" /> {t('hist.bulk.csv')}
      </Button>
      <Button size="sm" onClick={onXlsx} data-testid="bulk-export-xlsx-btn" variant="outline" className="bg-white text-emerald-700 border-emerald-300 hover:bg-emerald-50">
        <FileXls size={14} className="mr-1" /> {t('hist.bulk.xlsx')}
      </Button>
      <Button size="sm" onClick={onDelete} data-testid="bulk-delete-btn" variant="outline" className="bg-white text-red-700 border-red-300 hover:bg-red-50">
        <Trash size={14} className="mr-1" /> {t('hist.bulk.delete')}
      </Button>
      <button
        onClick={onClear}
        data-testid="clear-selection-btn"
        className="ml-auto text-xs text-blue-700 hover:underline"
      >
        {t('hist.bulk.clearSel')}
      </button>
    </div>
  );
}
